import { NavLink } from "react-router-dom";

const ITEMS = [
  { to: "/animals", label: "Stado", end: true },
  { to: "/animals/archive", label: "Archiwum", end: true },
  { to: "/irz", label: "Porównanie IRZ", end: true },
];

export function AnimalsSubnav() {
  return (
    <nav className="subnav" aria-label="Zwierzęta" data-testid="animals-subnav">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            isActive ? "subnav__link subnav__link--active" : "subnav__link"
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
